export { DMS_MODULE, MODULE_API } from '../constants';
export const NAME = 'NdObjednavka';
export const CRUMB_LABEL_LIST = 'grdMio';
export const CRUMB_LABEL_EDIT = 'edtMio';


export enum MioPznEnum {
	RychlaObjednavka = 1,
	SkladovaObjednavka = 2,
}
